import React from "react";
import { Tooltip, Box } from "@mui/material";

const TruncatedText = ({ text, maxLength = 50, sx = {} }) => {
  if (!text) return <span>-</span>;
  const strText = String(text);

  const baseStyles = {
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
    ...sx,
  };

  if (strText.length <= maxLength) {
    return <Box component="span" sx={baseStyles}>{strText}</Box>;
  }

  return (
    <Tooltip title={strText} arrow placement="top">
      <Box component="span" sx={{ cursor: "pointer", ...baseStyles }}>
        {strText.substring(0, maxLength) + "..."}
      </Box>
    </Tooltip>
  );
};

export default TruncatedText;
